export default "__VITE_ASSET__CKDqf6Lt__"